import PropTypes from "prop-types";

const PanelContent = ({ children }) => {
  return (
    <div
      data-testid="vt-sliding-panel-content"
      className="vt_sliding_panel__content"
    >
      {children}
    </div>
  );
};

PanelContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default PanelContent;
